import styled from "styled-components"
import { fontSize, space, color, fontWeight, textAlign } from "styled-system"

const Text: any = styled.div`
  text-decoration: none;
  ${color};
  ${fontSize};
  ${space};
  ${color};
  ${fontWeight};
  ${textAlign};
`

export default Text



// WEBPACK FOOTER //
// ./src/components/text/text.component.tsx